import template from './city-selector.html';
import controller from './city-selector.controller';

const citySelectorComponent = {
  bindings: {
    onUpdate: '&',
    cityId: '<',
    editing: '<',
    required: '<'
  },
  template,
  controller
};

export default citySelectorComponent;
